const MOBILE_MAX_WIDTH = 640;

function createConsultPresentation() {
  return { visible: false, mode: "centered", unread: false };
}

function reduceConsultPresentation(state, event) {
  switch (event.type) {
    case "open":
      return { ...state, visible: true, mode: "centered", unread: false };
    case "minimize":
      return { ...state, visible: false, mode: "collapsed" };
    case "consultant-complete":
    case "remote-consultant-complete":
      return state.visible ? state : { ...state, unread: true };
    case "remote-output-viewed":
      return state.unread ? { ...state, unread: false } : state;
    case "composer-focus":
      return {
        ...state,
        mode: event.viewportWidth <= MOBILE_MAX_WIDTH ? "fullscreen" : "expanded",
      };
    case "composer-blur":
      if (
        event.viewportWidth > MOBILE_MAX_WIDTH
        && !event.draft.trim()
        && !event.busy
        && !event.formPending
      ) {
        return { ...state, mode: "collapsed" };
      }
      return state;
    default:
      return state;
  }
}

// iOS Safari auto-zooms any focused input whose font-size is under 16px.
// On the same breakpoint the panel goes fullscreen, every Consultant field
// grows to 16px; desktop keeps its designed size (or `inherit`).
function consultFieldFontSize(viewportWidth, desktopSize) {
  return Number.isFinite(viewportWidth) && viewportWidth <= MOBILE_MAX_WIDTH ? 16 : desktopSize;
}

export { MOBILE_MAX_WIDTH, consultFieldFontSize, createConsultPresentation, reduceConsultPresentation };
